export enum RouteNames {
  ROOT = '/',
  SIGN_UP = '/signup',
  SIGN_IN = '/signin',
  SET_PASSWORD = '/set-password',
  ADMIN_ROOT = '/admin',
  ADMIN_CREATE_USER = '/admin/create-user',
  ADMIN_LOGIN = '/admin/login',
  ENABLE_ADMIN = '/1_secret_2_admin_3_enabler_4',
  FEATURE_FLAGS = '/internal/featureflags',
  ADMIN_USERS = '/internal/users',
  LICENSES = '/licenses',
  MEETING_LINK = '/:meetingRoute/meetinglink',
  CREATE_MEETING = '/create/:meetingType?',
}
